import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Images } from "config/images";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: "rgba(3, 28, 52, 0.36)",
				mixBlendMode: "normal",
				boxShadow: "2px 3px 3px rgba(0, 0, 0, 0.06)",
				backdropFilter: "blur(12.5px)",
				borderRadius: 6,
				padding: 10,
				marginBottom: 10
			},
			title: {
				fontSize: 14,
				color: theme.palette.common.white,
				paddingBottom: 10,
				fontWeight: 500,
				borderBottom: `1px solid rgba(255, 255, 255, 0.15)`
			},
			bgPoint: {
				backgroundImage: `url(${Images.bannerPointLoyalty})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 45px",
				width: "100%",
				height: 45,
				borderRadius: 10,
				marginTop: 8
			},
			point: {
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 600,
				height: 45,
				justifyContent: "center",
				"& > img": {
					width: 18,
					height: 18,
					marginRight: 5
				}
			},
			titleNumber: {
				color: theme.palette.text.main,
				textAlign: "center",
				fontSize: 14
			},
			text: {
				color: theme.palette.common.white,
				fontSize: 14,
				height: 40,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center"
			},
			border: {
				borderLeft: "1px solid rgba(255, 255, 255, 0.15)",
				borderRight: "1px solid rgba(255, 255, 255, 0.15)"
			},
			titleNote: {
				color: theme.palette.text.main,
				textAlign: "center",
				fontSize: 12
			},
			inputPoint: {
				background: "#09184132",
				borderRadius: 6,
				textAlign: "center",
				fontSize: 16,
				padding: 2,
				color: theme.palette.error.dark
			},
			temporaryPurchasePoint: {
				color: theme.palette.common.white,
				fontSize: 14
			}
		}),
	{
		name: "RemainingPoints",
		index: 1
	}
);

export default useStyles;
